'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext } from 'react';
import type { PowerhouseClient } from '../client/create-client';
const ClientContext = createContext<PowerhouseClient | null>(null);
export function PowerhouseClientProvider(t0) {
  const $ = _c(3);
  const {
    client,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== client) {
    t1 = <ClientContext.Provider value={client}>{children}</ClientContext.Provider>;
    $[0] = children;
    $[1] = client;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/**
 * Read the {@link PowerhouseClient} provided by `PowerhouseSDKProvider`. Throws
 * if called outside the provider, so a missing provider fails loudly rather
 * than silently no-op'ing reactor calls.
 */
export function useClient() {
  const client = useContext(ClientContext);
  if (!client) {
    throw new Error("useClient must be used within a <PowerhouseSDKProvider>.");
  }
  return client;
}